<template>
  <div class="info-container">
      <div class="column items-center q-gutter-sm q-mb-lg">
        <q-avatar size="84px">
        <img src="@/assets/logo.png" alt="pay-r logo" />
      </q-avatar>


      <q-btn
        no-caps
        flat
        size="lg"
        color="primary"
        label="Select appointment"
        icon-right="arrow_forward_ios"
        to="/en/appointment"
      />

      <q-btn
        no-caps
        flat
        size="sm"
        color="primary"
        class="legal-button"
        label="Imprint and data protection"
        to="/en/data-protection-imprint"
      />
    </div>
  </div>
</template>

<script setup>
/* keine Logik nötig */
</script>
